import React, { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import './PortfolioDashboard.css';
import PortfolioSummary from './metrics/PortfolioSummary';
import PortfolioHoldingsChart from './metrics/PortfolioHoldingsChart';
import BalanceHistoryChart from './metrics/BalanceHistoryChart';
import FeePositionSummary from './metrics/FeePositionSummary';
import FeeTierHistoryChart from './metrics/FeeTierHistoryChart';
import TradeActivityMonitor from './TradeActivityMonitor.tsx';
import DashboardBottomLogo from "./DashboardBottomLogo.tsx";
import SectionTitle from './shared/SectionTitle';
import { useGlobalAutoRefreshStore, useAutoRefreshTrigger } from '../stores/useGlobalAutoRefreshStore';

const PortfolioDashboard: React.FC = () => {
  const queryClient = useQueryClient();
  const setActiveDashboard = useGlobalAutoRefreshStore((state) => state.setActiveDashboard);
  const refreshTrigger = useAutoRefreshTrigger('portfolio');

  // Set this dashboard as active when mounted, clear when unmounted
  useEffect(() => {
    setActiveDashboard('portfolio');
    return () => setActiveDashboard(null);
  }, [setActiveDashboard]);

  // When global refresh trigger changes, invalidate all queries to refetch data
  useEffect(() => {
    if (refreshTrigger > 0) {
      queryClient.invalidateQueries();
    }
  }, [refreshTrigger, queryClient]);

  return (
    <div className="portfolio-dashboard">
      {/* Dashboard Header */}
      <div className="dashboard-header">
        <SectionTitle
          title="Portfolio Dashboard"
        />
      </div>

      {/* Main Content - Constrained sections */}
      <div className="dashboard-content">
          {/* Portfolio Summary */}
          <PortfolioSummary />

          {/* Portfolio Holdings */}
          <PortfolioHoldingsChart />

          {/* Balance History */}
          <BalanceHistoryChart />

          {/* Fee Position (F-017) */}
          <FeePositionSummary />

          {/* Fee Tier History (F-017) */}
          <FeeTierHistoryChart />

          {/* Market Activity Monitor */}
          <TradeActivityMonitor />
      </div>


      <DashboardBottomLogo />
    </div>
  );
};

export default PortfolioDashboard;
